import { Component, inject, input } from '@angular/core';

import { BaseDeleteButtonComponent } from '../../../../../shared/base-classes/base-delete-button.component';
import { UltraMenuItemComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item/ultra-menu-item.component';
import { UltraMenuItemWrapperComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item-wrapper/ultra-menu-item-wrapper.component';
import { DialogsService } from '../../../../../shared/services/dialogs.service';
import { CustomersService } from '../../customers.service';

@Component({
	selector: 'app-customer-delete-button',
	templateUrl: 'customer-delete-button.component.html',
	imports: [UltraMenuItemWrapperComponent, UltraMenuItemComponent],
})
export class CustomerDeleteButtonComponent extends BaseDeleteButtonComponent {
	private _customersService = inject(CustomersService);
	private _dialogsService = inject(DialogsService);

	code = input<string>();

	onDelete() {
		this._dialogsService.openDeleteRecordDialog(
			{
				confirmed: () => {
					this._customersService.deleteRecord(this.id()).subscribe((res) => {
						this.onDeleteCalled.emit(res);
					});
				},
			},
			this.code(),
		);
	}
}
